/**
 * @descripton paths to public facing assets and media
 */
export const assetsUrl = './assets/'
export const imagesUrl = './assets/images/'
export const siteLogo = `${imagesUrl}site-logo.png`
export const siteIcon = `${imagesUrl}site-icon.png`
